import React from "react";
import Email from "./email";
import Message from './sms'
import Notification from './notification'
import WhatsappChat from "./whatsaapp.container";
import Whatsappbhicash from "./Whatsappbhicash";
import CommentsNew from "./commentsNew";
import { getUserDetailApi } from "../../../Dashboard/DashboardActionCreator.component";
import { APIS } from "../../../../../utils/api-factory";
import { CHECK_COMPANY_TENANT, ABHICASH_LIKE, CREDFIN_LIKE } from "../../../../../layouts/MainTenantconfig";
import Chat from "./Chat";

class CommTab extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            viewTab: 'email'
        }
    }
    buttonHandle(type) {
        this.setState({ viewTab: type })
    }
    componentDidMount() {
        const { allDetail, userDetail, admin } = this.props


    }
    render() {
        const { allDetail, userDetail, admin } = this.props;
        const width = `${100 / 6}%`;

        return (
            <div className="container-fluid details-new">
                <style>{`
                    .scrollable-btn-group::-webkit-scrollbar {
                        display: none;
                    }
                `}</style>
                <div className="btn-group btn-grp-own scrollable-btn-group" role="group" aria-label="onboard-btn" style={{
                    marginTop: '10px',
                    padding: '10px',
                    display: 'flex',
                    flexWrap: 'nowrap',
                    overflowX: 'auto',
                    width: '100%',
                    maxWidth: '100%',
                    WebkitOverflowScrolling: 'touch',
                    scrollbarWidth: 'none',
                    msOverflowStyle: 'none',
                }}>
                    <button className="btn btn-outline-primary" style={{ background: this.state.viewTab === 'email' ? '#1D3557' : '#F1F7FF', color: this.state.viewTab === 'email' ? '#fff' : '#000', width: 'auto', flex: '1 1 auto', whiteSpace: 'nowrap', padding: '12px 15px', fontSize: '11px' }} onClick={() => this.buttonHandle('email')}> Email </button>
                    <button className="btn btn-outline-primary" style={{ background: this.state.viewTab === 'whatsapp' ? '#1D3557' : '#F1F7FF', color: this.state.viewTab === 'whatsapp' ? '#fff' : '#000', width: 'auto', flex: '1 1 auto', whiteSpace: 'nowrap', padding: '12px 15px', fontSize: '11px' }} onClick={() => this.buttonHandle('whatsapp')} > Whatsapp </button>
                    <button className="btn btn-outline-primary" style={{ background: this.state.viewTab === 'SMS' ? '#1D3557' : '#F1F7FF', color: this.state.viewTab === 'SMS' ? '#fff' : '#000', width: 'auto', flex: '1 1 auto', whiteSpace: 'nowrap', padding: '12px 15px', fontSize: '11px' }} onClick={() => this.buttonHandle('SMS')} > SMS </button>
                    <button className="btn btn-outline-primary" style={{ background: this.state.viewTab === 'Notification' ? '#1D3557' : '#F1F7FF', color: this.state.viewTab === 'Notification' ? '#fff' : '#000', width: 'auto', flex: '1 1 auto', whiteSpace: 'nowrap', padding: '12px 15px', fontSize: '11px' }} onClick={() => this.buttonHandle('Notification')} > Notification </button>
                    <button className="btn btn-outline-primary" style={{ background: this.state.viewTab === 'comments' ? '#1D3557' : '#F1F7FF', color: this.state.viewTab === 'comments' ? '#fff' : '#000', width: 'auto', flex: '1 1 auto', whiteSpace: 'nowrap', padding: '12px 15px', fontSize: '11px' }} onClick={() => this.buttonHandle('comments')} > Comments </button>
                    <button className="btn btn-outline-primary" style={{ background: this.state.viewTab === 'chat' ? '#1D3557' : '#F1F7FF', color: this.state.viewTab === 'chat' ? '#fff' : '#000', width: 'auto', flex: '1 1 auto', whiteSpace: 'nowrap', padding: '12px 15px', fontSize: '11px' }} onClick={() => this.buttonHandle('chat')} > Chat </button>


                </div>
                {this.state.viewTab === 'email' ?
                    <div className="container-fluid details-new">
                        <Email admin={admin} userDetail={userDetail} allDetail={allDetail} />
                    </div>
                    : ""}
                {this.state.viewTab === 'SMS' ?
                    <div className="container-fluid details-new">
                        <Message admin={admin} userDetail={userDetail} allDetail={allDetail} />
                    </div>
                    : ""}
                {this.state.viewTab === 'Notification' ?
                    <div className="container-fluid details-new">
                        <Notification admin={admin} userDetail={userDetail} allDetail={allDetail} />
                    </div>
                    : ""}
                {this.state.viewTab === 'whatsapp' && !CHECK_COMPANY_TENANT(ABHICASH_LIKE) ?
                    <div className="container-fluid details-new">
                        <WhatsappChat admin={admin} userDetail={userDetail} allDetail={allDetail} />
                    </div>
                    : ""}
                {this.state.viewTab === 'whatsapp' && CHECK_COMPANY_TENANT(ABHICASH_LIKE) ?
                    <div className="container-fluid details-new">
                        <Whatsappbhicash admin={admin} userDetail={userDetail} allDetail={allDetail} />
                    </div>
                    : ""}
                {this.state.viewTab === 'comments' ?
                    <div className="container-fluid details-new">
                        <CommentsNew admin={admin} userDetail={userDetail} allDetail={allDetail} />
                    </div>
                    : ""}
                {this.state.viewTab === 'chat' ?
                    <div className="container-fluid details-new">
                        <Chat admin={admin} allDetail={allDetail} />
                    </div>
                    : ""}
            </div>
        )
    }
}
export default CommTab